let { HI } = require("h-token-staking")
let { abi, bytecode } = require("./abi/Store.json")
let { charCompare,multiplication,longHandle } = require("h-token-staking/src/utils")
class Store extends HI {
    constructor({ provider, account, rpcUrl, privateKey, contract }) {
        super({ provider, account, rpcUrl, privateKey, contract, abi })
        this.maxVal = "999000000000000000000000000000000000000000000000000"
        this.mainToken = "0x0000000000000000000000000000000000000000"
    }

    async mint({ uid, nft, list },submit = true) {
        let config = await this.platformConfig()
        let temp = []
        temp = list.map(item => {
            return [
                item.recipient,
                item.amount,
                item.uri
            ]
        })
       
        let parmas = await this.buildTx("mint", [
            uid, nft,temp
        ],multiplication(config.mintAmount,temp.length))
        if(submit) {
            let result = parmas && await this.broadTx(parmas)
            return result
        }else {
            let result = parmas && await this.readTx(parmas)
            return result
        }
        
    }

    async nftDeploy({ contractType,name,symbol,author,royalty },submit = true) {
        royalty = longHandle(royalty,2)
        let config = await this.platformConfig()
        let parmas = await this.buildTx("deploy", [
            contractType,name,symbol,author,royalty
        ],config.deployAmount)
        if(submit) {
            let { logs } = parmas && await this.broadTx(parmas)
            let topic0 = "0x124e6dc3fd85aaab28d2e91013436a25aa12e9f874d5bb4248c0eb027ce5563b"
            let deployEvent = logs.find(item => {
                return charCompare(item.topics[0],topic0)
            })
            if(deployEvent) {
                let { data } = deployEvent
                let nft = "0x" + data.slice(2,66).slice(24)
                let owner = "0x" + data.slice(66).slice(24,64)
                let params = { nft,owner }
                return params
            }
        }else {
            let result = parmas && await this.readTx(parmas)
            return result
        }
        return false
    }

    async deployPlatform({ contractType,name,symbol,author,royalty },submit = true) {
        royalty = longHandle(royalty,2)
        let parmas = await this.buildTx("deployPlatform", [
            contractType,name,symbol,author,royalty
        ])
        if(submit) {
            let { logs } = parmas && await this.broadTx(parmas)
            let topic0 = "0x124e6dc3fd85aaab28d2e91013436a25aa12e9f874d5bb4248c0eb027ce5563b"
            let deployEvent = logs.find(item => {
                return charCompare(item.topics[0],topic0)
            })
            if(deployEvent) {
                let { data } = deployEvent
                let nft = "0x" + data.slice(2,66).slice(24)
                let owner = "0x" + data.slice(66).slice(24,64)
                let params = { nft,owner }
                return params
            }
        }else {
            let result = parmas && await this.readTx(parmas)
            return result
        }
        return false
    }

    async deployStore() {
        try {
            let from = this.web3.eth.defaultAccount
            let gasPrice = await this.GasPrice()
            let result = await this.SC.deploy({
                data: bytecode,
                arguments: []
            }).send({ from, gasPrice });
            this.SC = result
            return result
        } catch (err) {
            console.log(err)
        }
    }

    async updateConfig({ feeWallet,deployAmount,mintAmount }) {
        deployAmount = longHandle(deployAmount,18)
        mintAmount = longHandle(mintAmount,18)
        let parmas = await this.buildTx("updateConfig", [
            feeWallet,deployAmount,mintAmount
        ])
        let result = parmas && await this.broadTx(parmas)
        return result
    }

    async setDefaultRoyalty({ nft,author,royalty }) {
        royalty = longHandle(royalty,2)
        let parmas = await this.buildTx("setDefaultRoyalty", [
            nft,author,royalty
        ])
        let result = parmas && await this.broadTx(parmas)
        return result
    }

    async platformSupport(nft) {
        let support = await this.SC.methods.platformSupport(nft).call()
        return support
    }

    async platformConfig() {
        let config = await this.SC.methods.config().call()
        return config
    }

    async platformContract(nft) {
        let support = await this.SC.methods.platformContract(nft).call()
        return support
    }

    async nftOwner(nft) {
        let owner = await this.SC.methods.nftOwner(nft).call()
        return owner
    }

    async platformOwner() {
        let owner = await this.SC.methods.owner().call()
        let isOwner = charCompare(owner,this.web3.eth.defaultAccount)
        return isOwner
    }

    async isOwner(nft) {
        let owner = await this.nftOwner(nft)
        let isOwner = charCompare(owner,this.web3.eth.defaultAccount)
        return isOwner
    }
}


module.exports = Store